import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Reveal } from './Reveal';
import { GoldBow } from './GoldBow';
import { Button } from './Button';
import { Tilt3D } from './Tilt3D';
import { IconClose } from './icons';
import { scrollToLeadForm } from '../utils/scroll';
const TYPICAL = ['exp.typical.1', 'exp.typical.2', 'exp.typical.3', 'exp.typical.4', 'exp.typical.5'];
const QUEEN = ['exp.queen.1', 'exp.queen.2', 'exp.queen.3', 'exp.queen.4', 'exp.queen.5'];
export function QueenExperience() {
  const {
    t
  } = useLanguage();
  return <section className="w-full bg-offwhite" data-id="element-308" data-mp="3l9axw0gw8j0b">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 sm:px-6 md:py-24" data-id="element-309" data-mp="2xnvvcqv83pc">
        <Reveal className="max-w-2xl" data-id="element-310" data-mp="3v1gp37zbmweg">
          <p className="font-display text-[11px] font-bold uppercase tracking-[0.24em] text-camelink" data-id="element-311" data-mp="3v2i23hzwdsyt">
            {t('exp.eyebrow')}
          </p>
          <div aria-hidden="true" className="mt-3 h-[3px] w-12 bg-kred" data-id="element-312" data-mp="7wipzaua9eor" />
          <h2 className="mt-5 font-display text-3xl font-extrabold uppercase leading-[1.02] tracking-[-0.02em] text-ink sm:text-5xl" data-id="element-313" data-mp="7ybxescq02xt">
            {t('exp.title')}
          </h2>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-2 lg:gap-8" data-id="element-314" data-mp="12bfoacla464a">
          <Reveal data-id="element-315" data-mp="179h66u6yxze6">
            <Tilt3D className="h-full" max={4} data-id="element-316" data-mp="178z25be2egvp">
              <div className="h-full border border-ink/10 bg-white/60 p-6 sm:p-8" data-id="element-317" data-mp="1bcdiy49tv1a7">
              <h3 className="font-display text-sm font-extrabold uppercase tracking-[0.18em] text-muted" data-id="element-318" data-mp="1gayie1h99gxl">
                {t('exp.typicalTitle')}
              </h3>
              <ul className="mt-6 space-y-4" data-id="element-319" data-mp="1l8742c1m433l">
                {TYPICAL.map(key => <li key={key} className="flex items-start gap-3 text-base text-muted" data-id="element-320" data-mp="1q1a0crxrxqnh">
                    <IconClose className="mt-1 h-4 w-4 shrink-0 text-muted/60" data-id="element-321" data-mp="1uyjm9xlyfk6k" />
                    <span data-id="element-322" data-mp="1z27vekq8intx">{t(key)}</span>
                  </li>)}
                </ul>
              </div>
            </Tilt3D>
          </Reveal>

          <Reveal delay={0.1} data-id="element-323" data-mp="23y6qss9zd63u">
            <Tilt3D className="h-full" max={4} lift={10} data-id="element-324" data-mp="3xi88le2c6ej">
              <div className="relative h-full border border-ink/10 border-t-2 border-t-camel bg-white p-6 shadow-[0_20px_50px_-32px_rgba(5,20,31,0.45)] sm:p-8" data-id="element-325" data-mp="3vxdaunu6lg5">
              {/* Red as a point color: the badge only. Never a button fill. */}
              <span className="absolute -top-3 left-6 bg-kred px-3 py-1 font-display text-[10px] font-extrabold uppercase tracking-[0.2em] text-white" data-id="element-326" data-mp="8x4jwqe8tel8">
                {t('exp.badge')}
              </span>
              <h3 className="mt-3 font-display text-sm font-extrabold uppercase tracking-[0.18em] text-ink" data-id="element-327" data-mp="im4lmhk4qo34">
                {t('exp.queenTitle')}
              </h3>
              <ul className="mt-6 space-y-4" data-id="element-328" data-mp="rnumsf3td1e3">
                {QUEEN.map(key => <li key={key} className="flex items-start gap-3 text-base font-medium text-ink" data-id="element-329" data-mp="rm1hb34xsn7o">
                    {/* The gold bow as the bullet marker. */}
                    <GoldBow className="mt-1 h-4 w-5 shrink-0" color="#B08355" strokeWidth={1.6} data-id="element-330" data-mp="2tgiryu00pywi" />
                    <span data-id="element-331" data-mp="18yhuwdwg5vv8">{t(key)}</span>
                  </li>)}
              </ul>
                <Button type="button" onClick={scrollToLeadForm} block className="mt-8" data-id="element-332" data-mp="1dvrps92luzqg">
                  {t('exp.cta')}
                </Button>
              </div>
            </Tilt3D>
          </Reveal>
        </div>
      </div>
    </section>;
}